import { Component, HostBinding, inject, OnInit } from '@angular/core';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

import { VersionCheckService } from '@bn/shared/core/services';
import { ButtonComponent } from '@bn/web-ui/button/button.component';

@Component({
  selector: 'bn-dashboard-update-notification',
  styleUrls: ['./update-notification.component.scss'],
  templateUrl: 'update-notification.component.html',
  imports: [ButtonComponent, FaIconComponent, TooltipModule],
})
export class UpdateNotificationComponent implements OnInit {
  private versionCheckService = inject(VersionCheckService);

  @HostBinding('class.visible') isVisible = false;
  public ngOnInit() {
    this.isVisible = true; // for sexy animations on component load
  }

  public onRefreshAppClick() {
    window.location.reload();
  }

  public onCloseClick() {
    this.versionCheckService.hideNotification(15, 'minutes');
  }
}
